<script>
    import NauiSelect from "../../../../naui/atoms/NauiSelect.svelte";
    import NauiInput from "../../../../naui/atoms/NauiInput.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let data_step__2;

    let knownCategoryValues = ""


    let departementos = "";

    async function doPost() {
        console.log(knownCategoryValues)
        var raw = JSON.stringify({
            knownCategoryValues
        });

        var requestOptions = {
            method: 'POST',
            // headers: {"Content-type": "application/json",
            // "Access-Control-Allow-Origin": "http://127.0.0.1:5000",
            //     "Access-Control-Allow-Credentials": "true"
            // },
            headers: {"Content-type": "application/json"},
            // mode: 'no-cors',
            body: raw,
            redirect: 'follow',
        };
        fetch("http://127.0.0.1:8000/siniestros/departamentos", requestOptions)
            .then(response => response.json())
            .then(result => {
                departementos = result;
                console.log(departementos)
            })
            .catch(error => console.log('error', error));
    }

    let cod_Pais = knownCategoryValues;
    let cod_dpto = "";
    let ciudades = "";


    async function get_ciudades() {
        cod_Pais = knownCategoryValues
        console.log(cod_Pais, cod_dpto)
        var raw2 = JSON.stringify({
            cod_Pais,
            cod_dpto
        });

        var requestOptions2 = {
            method: 'POST',
            // headers: {"Content-type": "application/json",
            // "Access-Control-Allow-Origin": "http://127.0.0.1:5000",
            //     "Access-Control-Allow-Credentials": "true"
            // },
            headers: {"Content-type": "application/json"},
            // mode: 'no-cors',
            body: raw2,
            redirect: 'follow',
        };

        fetch("http://127.0.0.1:8000/siniestros/ciudades", requestOptions2)
            .then(response => response.json())
            .then(result => {
                ciudades = result;
                console.log(ciudades)
            })
            .catch(error => console.log('error', error));
    }

    let dispatch = createEventDispatcher();

    export let parametros_step_2;
    // ToDo reemplazar por data real
    export let asegurado = {
        nombre: 'Ana María Giraldo',
        identificacion: '1025457878',
        poliza: '654123654',
        fechaSiniestro: '12/02/2021',
        marca: 'RENAULT',
        linea: 'DUSTER (FL) DYNAIMIQUE MT 1600CC 4x2',
        modelo: 2019,
        placa: 'FHY605'
    };


    function next() {
        dispatch('next')
    }

    function prev() {
        dispatch('prev')
    }


</script>
<section>
    <fieldset>
        <legend>Datos del asegurado</legend>
        <table class="simple-table">
            <tr>
                <td style="min-width: 200px">Nombre</td>
                <td><strong>{asegurado['nombre']}</strong></td>
            </tr>
            <tr>
                <td>Identificación</td>
                <td><strong>{asegurado['identificacion']}</strong></td>
            </tr>
            <tr>
                <td>No. Póliza</td>
                <td><strong>{asegurado['poliza']}</strong></td>
            </tr>
            <tr>
                <td>Fecha siniestro</td>
                <td><strong>{asegurado['fechaSiniestro']}</strong></td>
            </tr>
            <tr>
                <td>Marca</td>
                <td><strong>{asegurado['marca']}</strong></td>
            </tr>
            <tr>
                <td>Línea - Clase</td>
                <td><strong>{asegurado['linea']}</strong></td>
            </tr>
            <tr>
                <td>Modelo</td>
                <td><strong>{asegurado['modelo']}</strong></td>
            </tr>
            <tr>
                <td>Placa</td>
                <td><strong>{asegurado['placa']}</strong></td>
            </tr>
        </table>
    </fieldset>
    <hr>
    <div class="mt-1 mb-15 back-gray p-ii px-1 radius w-max-content">
        <p>Por favor <strong>verificar y corregir</strong> la siguiente información en caso de ser necesario.</p>
    </div>
    <div class="grid-5 gap-1 mb-1">
        <NauiSelect label="Género" options="[]"/>
        <NauiInput type="email" label="Correo"/>
    </div>
    <div class="grid-5 gap-1 mb-1">
        <NauiInput label="Celular"/>
        <NauiInput label="Otro teléfono de contacto"/>
        <div class="col-2">
            <NauiInput label="Dirección"/>
        </div>
    </div>
    <fieldset>
        <legend>Datos del evento</legend>
        <div class="grid-5 gap-1 mb-1">
            <NauiSelect label="País del evento" options={data_step__2.paises} bind:value={knownCategoryValues}
                        on:change={doPost}/>
            <NauiSelect label="Departamento del evento" options={departementos} bind:value={cod_dpto}
                        on:change={get_ciudades}/>
            <NauiSelect label="Ciudad del evento" options={ciudades}/>
        </div>
        <div class="grid-5 gap-1 mb-1">
            <NauiSelect label="Dirección" options={parametros_step_2.direcciones}/>
            <div class="col-2 box-b sx-ii">
                <div class="naui-field">
                    <input class="naui-input" style="max-width: 70px" type="text">
                </div>
                <div class="naui-field">
                    <input class="naui-input" style="max-width: 70px" type="text">
                </div>
                <span class="secondary px-ii">#</span>
                <div class="naui-field">
                    <input class="naui-input" style="max-width: 70px" type="text">
                </div>
                <div class="naui-field">
                    <input class="naui-input" style="max-width: 70px" type="text">
                </div>
                <span class="secondary px-ii">-</span>
                <div class="naui-field">
                    <input class="naui-input" style="max-width: 70px" type="text">
                </div>
            </div>
            <NauiInput label="Observaciones"/>
        </div>
        <div class="grid-5 gap-1">
            <div class="col-2">
                <NauiInput label="Dirección"/>
            </div>
            <NauiSelect label="Localización" options="[]"/>
        </div>
    </fieldset>
    <div class="box-l sx-1">
        <NauiButton caption="Regresar" mode="outline" color="accent" className="min-w-200px" on:click={prev}/>
        <NauiButton caption="Continuar" mode="solid" color="accent" className="min-w-200px" on:click={next}/>
    </div>
</section>